import { Controller } from "stimulus"

// Pose-reference picker for the fashion single-generation form.
//
// - A hidden input (target=input) holds the selected pose_reference_id.
// - A row of clickable thumbnails (target=thumb) toggles the selection on click.
// - "Clear" deselects and zeros the hidden input.
// - Optionally filters thumbnails by gender, hooked up to the industry-toggle
//   gender radios via an "outside" custom event ("pose-picker:gender-changed").
export default class extends Controller {
  static targets = ["input", "thumb"]

  connect() {
    // Reflect current value visually if it was persisted on a re-render.
    const currentId = (this.hasInputTarget && this.inputTarget.value) || ""
    if (currentId) this._highlight(currentId)

    // Listen to gender changes broadcast by industry-toggle.
    this._onGender = (e) => this._applyGenderFilter(e.detail && e.detail.gender)
    window.addEventListener("pose-picker:gender-changed", this._onGender)
  }

  disconnect() {
    window.removeEventListener("pose-picker:gender-changed", this._onGender)
  }

  select(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const id = btn.getAttribute("data-pose-id")
    const current = this.inputTarget.value
    if (current === id) {
      // toggle off
      this.inputTarget.value = ""
      this._highlight("")
    } else {
      this.inputTarget.value = id
      this._highlight(id)
    }
  }

  clear(event) {
    if (event) event.preventDefault()
    this.inputTarget.value = ""
    this._highlight("")
  }

  _highlight(id) {
    this.thumbTargets.forEach((t) => {
      if (t.getAttribute("data-pose-id") === id && id) {
        t.classList.add("is-selected")
        t.style.outline = "3px solid var(--piktiz-pink)"
        t.style.outlineOffset = "-1px"
      } else {
        t.classList.remove("is-selected")
        t.style.outline = ""
        t.style.outlineOffset = ""
      }
    })
  }

  _applyGenderFilter(gender) {
    // gender from the form radios: woman / man / boy / girl. Map to
    // PoseReference tag: female / male / unisex. Unisex always visible.
    let want = null
    if (gender === "woman" || gender === "girl") want = "female"
    else if (gender === "man" || gender === "boy") want = "male"

    this.thumbTargets.forEach((t) => {
      const g = t.getAttribute("data-gender")
      const visible = !want || g === want || g === "unisex"
      t.style.display = visible ? "" : "none"
    })
  }
}
